export enum FleetingLabelDuration {
  Fast,
  Normal,
  Slow,
  Slower,
  VerySlow,
}
